export const HERO_SEQUENCE = {
  logoDelayMs: 400,
  waveDelayMs: 800,
  navDelayMs: 1100,
} as const;

export const HERO_ANIMATION = {
  ease: [0.25, 0.1, 0.25, 1] as const,
  tagline: { duration: 0.45 },
  logo: { duration: 0.45 },
  carousel: { duration: 0.3 },
  controls: { delayAfterReady: 0 },
} as const;

export const HERO_TEAMS_SETTLE_FALLBACK_MS = 280;

export const LANDING_PERF_HERO_COMPONENT = 'LandingPerf.Chero';
export const LANDING_PERF_HERO_SEQUENCE_MESSAGE = 'hero-sequence';
export const LANDING_PERF_HERO_TEAMS_DATA_MESSAGE = 'hero-teams-data';
